export default {
    /**
     *
     * @param h
     * @returns {*}
     */
    render(h) {
      return (
        <fragment>
          <router-view/>
          <router-view name="modal"/>
        </fragment>
      );
    }
  };